interface BitlyConfig {
    URL: string,
    token: string
}

export const bitlyConfig : BitlyConfig = {
    URL : "https://api-ssl.bitly.com/v4/shorten",
    token : "660abe0e214c0125d619c649310b4c75689417f4"
}